module.exports = __webpack_public_path__ + "static/media/IconLightMode.f5264de8.svg";